import { Component, computed, inject, input, output } from '@angular/core';
import { TaskDescriptionAcknowledgementCheckboxComponent } from '@app/components/task/task-description-acknowledgement-checkbox/task-description-acknowledgement-checkbox.component';
import { TaskDetailsDescriptionComponent } from '@app/components/task/task-details/task-details-description/task-details-description.component';
import { FileDropComponent } from '@app/shared/components/files/file-drop/file-drop.component';
import { FileMiniListComponent } from '@app/shared/components/files/file-mini-list/file-mini-list.component';
import { FileUploadListComponent } from '@app/shared/components/files/file-upload-list/file-upload-list.component';
import { FileActionsService } from '@app/shared/services/actions/file-actions.service';
import { FileContext } from '@app/shared/types/enums/file-enums';
import { FileInfo } from '@app/shared/types/models/files/file-info';
import { FileUploadInfo } from '@app/shared/types/models/files/file-upload-info';
import { TaskParticipant } from '@app/shared/types/models/task/task-participant.model';
import { Task } from '@app/shared/types/models/task/task.model';
import { UiExpandableContentComponent } from '@app/shared/ui/expandable-content/ui-expandable-content.component';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * @summary Task detail Description tab — editor, inline attachments, and acknowledgement.
 * @selector proffeo-task-details-description-tab
 */
@Component({
  selector: 'proffeo-task-details-description-tab',
  templateUrl: './task-details-description-tab.component.html',
  styleUrl: './task-details-description-tab.component.scss',
  imports: [
    TaskDetailsDescriptionComponent,
    UiExpandableContentComponent,
    FileDropComponent,
    FileMiniListComponent,
    FileUploadListComponent,
    TaskDescriptionAcknowledgementCheckboxComponent,
    TranslatePipe
  ]
})
export class TaskDetailsDescriptionTabComponent {
  private readonly fileActions = inject(FileActionsService);
  protected readonly FileContext = FileContext;
  protected readonly showAcknowledgeDescription = computed(
    () => !!this.task().acknowledgementRequested && this.taskParticipants().length > 0
  );

  public readonly task = input.required<Task>();
  public readonly descriptionFiles = input.required<FileInfo[]>();
  public readonly activeUploads = input.required<FileUploadInfo[]>();
  public readonly descriptionHasUnsavedChanges = input.required<boolean>();
  public readonly taskParticipants = input.required<TaskParticipant[]>();

  public readonly descriptionChange = output<string>();
  public readonly unsavedChangesChange = output<boolean>();
  public readonly descriptionFilesAdded = output<File[]>();
  public readonly fileDelete = output<FileInfo>();
  public readonly avatarSet = output<FileInfo>();

  protected cancelUpload(uploadId: string | undefined): void {
    if (uploadId) this.fileActions.cancelUpload(uploadId);
  }

  protected dismissUpload(uploadId: string | undefined): void {
    if (uploadId) this.fileActions.dismissUpload(uploadId);
  }
}
